__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@vaisala/sampo-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hookform/resolvers", "3.9.1", () => (Promise.all([__webpack_require__.e(35), __webpack_require__.e(847)]).then(() => (() => (__webpack_require__(37847))))));
			register("@reduxjs/toolkit", "2.5.0", () => (Promise.all([__webpack_require__.e(109), __webpack_require__.e(673)]).then(() => (() => (__webpack_require__(70673))))));
			register("@vaisala-ebu/react", "2.0.83", () => (Promise.all([__webpack_require__.e(518), __webpack_require__.e(880), __webpack_require__.e(50), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(704), __webpack_require__.e(431), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(19880))))));
			register("@vaisala-ebu/shell-events", "1.8.3", () => (__webpack_require__.e(449).then(() => (() => (__webpack_require__(11449))))));
			register("@vaisala-ebu/shell-model", "1.8.0", () => (__webpack_require__.e(93).then(() => (() => (__webpack_require__(75093))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))));
			register("flatpickr", "4.6.13", () => (__webpack_require__.e(290).then(() => (() => (__webpack_require__(38290))))));
			register("i18next-http-backend", "3.0.1", () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(68914))))));
			register("i18next", "24.1.2", () => (__webpack_require__.e(978).then(() => (() => (__webpack_require__(44978))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-hook-form", "7.54.1", () => (Promise.all([__webpack_require__.e(858), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(24858))))));
			register("react-i18next", "15.2.0", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(74117))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(3), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(83003))))));
			register("react-router-dom", "6.27.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("recharts", "2.15.0", () => (Promise.all([__webpack_require__.e(270), __webpack_require__.e(516), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(83516))))));
			register("styled-components", "6.1.13", () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(62153))))));
			register("zod-error", "1.5.0", () => (Promise.all([__webpack_require__.e(146), __webpack_require__.e(406)]).then(() => (() => (__webpack_require__(13406))))));
			register("zod", "3.24.1", () => (__webpack_require__.e(665).then(() => (() => (__webpack_require__(97665))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};